import { HgSupportedLanguage } from '@smg-real-estate/domus';
import { type GeoLocation } from '@smg-real-estate/geo-libs';
import { computed, type Ref } from 'vue';
import { useRoute, type Route, type RouteLocationNormalized } from 'vue-router';

import { useAgencyProfilesStore } from '@/stores/agencyProfiles';

export interface RouteMeta {
  locale: HgSupportedLanguage;
  getLanguageSwitchLink: (
    route: Route,
    language: HgSupportedLanguage,
    selectedLocations: GeoLocation[],
  ) => RouteLocationNormalized;
}

const useRouteMeta = (): Ref<RouteMeta> => {
  const route = useRoute();
  return computed(() => route.meta as unknown as RouteMeta);
};

export const useLocale = (): Ref<HgSupportedLanguage> => {
  const routeMeta = useRouteMeta();
  return computed(() => routeMeta.value.locale);
};

export const useGetLanguageSwitchLink = (): Ref<(_language: HgSupportedLanguage) => unknown> => {
  const route = useRoute();

  return computed(() => (language: HgSupportedLanguage) => {
    const store = useAgencyProfilesStore();

    if (typeof route.meta?.getLanguageSwitchLink === 'function') {
      return (route.meta as unknown as RouteMeta).getLanguageSwitchLink(
        route,
        language,
        store.selectedLocations,
      );
    }
  });
};
